<template>
    <section class="content">
        <div class="row">
            <div class="col-md-12">

                <keywords-form :keyword="keyword" :loader="loader" @click="storeKeyword(keyword)" :showLabels="false"></keywords-form>

            </div>
        </div>
    </section>
</template>

<script>
  import types from '../../store/mutation-types'
  import keywordsApi from '../../api/keywords'
  import keywordsForm from './Form.vue'
  import Keyword from '../../models/keyword'

  export default {

    components: {
      keywordsForm
    },
    data () {
      return {
        keyword: new Keyword(),
        loader: false
      }
    },

    created () {
      this.$store.commit(types.SET_HEADER_STATE, {
        pageTitle: 'Inserisci nuova keyword',
        createButton: {display: false}
      })
    },

    methods: {
      storeKeyword (keyword) {
        this.loader = true
        keyword.archive_id = this.$store.state.profile.profile.archive.data.id
        keywordsApi.store(keyword)
          .then((response) => {
            toastr.success('La keyword è stata inserita correttamente')
            this.$router.push('/keywords')
          })
          .catch((response) => {
            this.loader = false
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/keywords/Create.vue